import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Sheet from "components/shared/Sheet";
import Form from "../components/CreateForm";
import { useVisible } from "utils/hooks/useVisible";

export const useFormSheet = () => {
    const { t } = useTranslation();
    const { open, close, visible } = useVisible();

    const sheet = useMemo(() => {
        return (
            <Sheet
                title={t("create-open-shift")}
                open={visible}
                close={close}
                bodyClassName="tw-flex tw-flex-col tw-overflow-hidden"
            >
                <Form close={close} />
            </Sheet>
        )
    }, [close, visible, t]);

    return { open, sheet };
}
